module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/169-liberia-9efefeeff4e4a75635369eafe9014dff.svg";